import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/avatar.jpg'


const _withScopeId = n => (_pushScopeId("data-v-00e6ee34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspector" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  class: "avatar"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "col-sm-6 text-right" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn btn-sm btn-outline-secondary document-upload-button" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-upload" }),
    /*#__PURE__*/_createTextVNode(" Upload google calendar")
  ])
], -1))
const _hoisted_13 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_21 = { class: "container-fluid" }
const _hoisted_22 = {
  id: "status-bar-actions",
  style: {"margin-left":"auto"}
}
const _hoisted_23 = { class: "text-light" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_29 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "fas fa-save"
}

import { ref, computed, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { Inspector } from '@/models'; // Adjust the path accordingly
import { useRoute, useRouter } from 'vue-router';
import _ from 'lodash';
import { useToast } from "vue-toastification";
import sanitize from 'sanitize-filename';
import moment from 'moment-timezone';
import { emitEvent } from '@/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ical = require('node-ical');
const actProperty: any = inject('actProperty');
const router = useRouter();
const route = useRoute();
const store = useStore();
const toasted = useToast();
const file = ref(null);

const unsavedChanges = ref(false);
const uploading = ref(false);
const isSaving = ref(false);
const toast = useToast();
const hasUnsavedChanges = computed(() => store.getters['inspectors/hasUnsavedChanges']);
const inspector = computed(() => store.getters['inspectors/current']);
const getDefaultInspector = async () => {
  return store.dispatch('inspectors/getDefaultInspector');
};

const getInspector = async (id: string) => {
  return store.dispatch('inspectors/getInspector', id);
};

const addInspector = async (inspector: Inspector) => {
  return store.dispatch('inspectors/addInspector', inspector);
};

const updateInspector = async (inspector: Inspector) => {
  return store.dispatch('inspectors/updateInspector', inspector);
};

const setInspector = async (inspector: Inspector) => {
  return store.commit('inspectors/setInspector', inspector);
};

const importGoogleBookings = async (bookings: any[]) => {
  return store.dispatch('diary/importGoogleBookings', bookings);
};

const resetUnsavedChanges = (): void => {
  store.commit('inspectors/resetUnsavedChanges');
};

const isNewInspector = () => {
  return route.params.id == "new";
};

const onFileInputChange = (event: Event) => {
  const files = _.get(file.value, "files", null);
  uploadFiles(files);
};
const setUnsavedChanges = (value: boolean) => {
  unsavedChanges.value = value;
};

const uploadFiles = async (files: FileList | null) => {
  try {
    if (null === files || 0 === files.length) {
      return;
    }

    uploading.value = true;
    for (let i = 0; i < files.length; i++) {
      let file: File | null = files.item(i);

      if (file === null) {
        continue;
      }

      const { name, type } = file;

      if (type !== 'text/calendar') {
        toast.error(`${sanitize(name)} is not an ICS file.`);
        continue;
      }

      const timezone = process.env.VUE_APP_TIMEZONE || 'Europe/London';

      const events = await ical.sync.parseICS(await file.text());
      let bookings: any[] = [];

      // const marchStart = moment('2024-03-01T00:00:00.000Z');
      // const marchEnd = moment('2024-03-31T23:59:59.000Z');
      for (var key of Object.keys(events)) {
        let e = events[key];
        if (e.type === 'VEVENT' && e.uid && !e.rrule) {
          const booking: any = {
            invoices: [],
            inspector: { id: inspector.value.id },
            startdate: moment.tz(e.start, timezone).format('YYYY-MM-DD[T]HH:mm') + ':00.000Z',
            enddate: moment.tz(e.end, timezone).format('YYYY-MM-DD[T]HH:mm') + ':00.000Z',
            googleid: e.uid,
            description: e.description,
            summary: e.summary,
            location: e.location,
            recurrenceRule: e.rrule?.toString(),
          };
          // A temperary fix for last mopup
          // Only push if the startdate is between 1st and 31st March
          // const bm = moment(booking.startdate);
          // if(bm.isAfter(marchStart) && bm.isBefore(marchEnd)) {
          //   bookings.push(booking);
          // }
          bookings.push(booking);
          if (bookings.length >= 100) {
            await importGoogleBookings(bookings);
            bookings = [];
          }
        }
      }

      if (bookings.length) {
        await importGoogleBookings(bookings);
        bookings = [];
      }
    }
    uploading.value = false;
  } catch (error) {
    uploading.value = false;
    toast.error(error);
  }  
};

onMounted(async () => {
  if (isNewInspector()) {
    setInspector(new Inspector());
    return;
  }
  try {

    const values = await Promise.all([getDefaultInspector(), getInspector(route.params.id as string)]);
    const inspector: Inspector = values[1];

    if (inspector === undefined) {
      toast.error(`Could not find inspector with ID ${route.params.id as string}`);
      router.push({ name: 'inspectorlist' });
    }

    const defaultinspector: Inspector = values[0];

    if (isNewInspector()) {
      const defaultinsp: Inspector = new Inspector(defaultinspector);
      defaultinsp.id = '';
      defaultinsp.name = '';
      setInspector(defaultinsp);
      return;
    }
    emitEvent('inspectorLoadedOnSchedulingPage', inspector);

  } catch (err) {
    toast.error(err);
  }
});

const saveAll = async () => {
  if (isNewInspector()) {
    isSaving.value = true;
    try {
      const newInspector = await addInspector(inspector.value);
      isSaving.value = false;
      toasted.success('Saved');
      router.push(`/inspectors/${newInspector.id}`);
      setUnsavedChanges(false);
    } catch (err) {
      isSaving.value = false;
      toasted.error(err);
    }
  } else {
    isSaving.value = true;
    try {
      await updateInspector(inspector.value);
      isSaving.value = false;
      toasted.success('Updated');
      setUnsavedChanges(false);
    } catch (err) {
      isSaving.value = false;
      toasted.error(err);
    }
  }
};
const cancel = () => {
  resetUnsavedChanges();
  router.push({name:'inspectorlist'});
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        (inspector.value != undefined && inspector.value.picture &&
          inspector.value.picture.length &&
          inspector.value.picture[0].src
          )
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(actProperty).s3Origin(inspector.value.picture[0].src),
              class: "avatar"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5)),
        (isNewInspector())
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Add Inspector"))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(inspector.value.name), 1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (uploading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" Uploading google calendar")
            ]))
          : (_openBlock(), _createElementBlock("label", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("input", {
                type: "file",
                accept: "application/ics",
                ref_key: "file",
                ref: file,
                onChange: onFileInputChange
              }, null, 544)
            ]))
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_13, [
        _createElementVNode("li", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: "address",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Address ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: "ratecard",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Rate card ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_16, [
          _createVNode(_component_router_link, {
            to: "preferredlocations",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Preferred locations ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: "preferredclients",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Preferred clients ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "excludedclients",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Excluded clients ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "scheduling",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Scheduling ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_25, "No unsaved changes")),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancel()), ["prevent"])),
                disabled: !hasUnsavedChanges.value
              }, [
                _hoisted_28,
                _createTextVNode(" Cancel ")
              ], 10, _hoisted_27)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
                disabled: isSaving.value || !hasUnsavedChanges.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33))
                  : (_openBlock(), _createElementBlock("i", _hoisted_34)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_30)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})